// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"351":"commons","532":"styles","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"351":"b9ecffe2f2fb6c8ce0c0","532":"b4036d6ba7217348ce0d","678":"e633f1c7a7e1cba04a94","883":"325846ac224c4d9388ad"}[chunkId] + ".js";
};